import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { StepIndicator } from '../components/training/StepIndicator';
import { Step1TrainingInfo } from '../components/training/Step1TrainingInfo';
import { Step2BatchInfo } from '../components/training/Step2BatchInfo';
import { Step3Schedule } from '../components/training/Step3Schedule';
import { Step4Trainees } from '../components/training/Step4Trainees';
import { Step5Publish } from '../components/training/Step5Publish';
import { Step6Attendance } from '../components/training/Step6Attendance';
import { Step7Certificates } from '../components/training/Step7Certificates';
import { TrainingWizardState, Trainer, Venue } from '../types';
const steps = [{
  number: 1,
  label: 'Training Info'
}, {
  number: 2,
  label: 'Batch Info'
}, {
  number: 3,
  label: 'Schedule'
}, {
  number: 4,
  label: 'Trainees'
}, {
  number: 5,
  label: 'Publish'
}, {
  number: 6,
  label: 'Attendance'
}, {
  number: 7,
  label: 'Certificates'
}];
export function TrainingWizardPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const [state, setState] = useState<TrainingWizardState>({
    training: {
      status: 'active',
      nameBangla: '',
      nameEnglish: '',
      category: '',
      description: ''
    },
    batch: {
      venueType: 'online',
      trainers: [],
      nameBangla: '',
      nameEnglish: '',
      trainingId: '',
      startDate: '',
      endDate: '',
      duration: 0,
      onlineLink: ''
    },
    schedules: [],
    selectedTrainees: [],
    attendance: {},
    certificates: [],
    currentStep: 1,
    isPublished: false
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [trainers] = useState<Trainer[]>([{
    id: '1',
    name: 'Dr. Ahmed Rahman',
    designation: 'Senior Trainer',
    phone: '01712345678',
    email: 'ahmed@example.com',
    organization: 'ekseba',
    status: 'active'
  }, {
    id: '2',
    name: 'Fatima Begum',
    designation: 'Training Coordinator',
    phone: '01812345678',
    email: 'fatima@example.com',
    organization: 'ekseba',
    status: 'active'
  }]);
  const [venues] = useState<Venue[]>([{
    id: '1',
    name: 'Main Training Center',
    address: 'Dhaka',
    capacity: 50,
    type: 'Training Center',
    status: 'active'
  }, {
    id: '2',
    name: 'Regional Office',
    address: 'Chittagong',
    capacity: 30,
    type: 'Office',
    status: 'active'
  }]);
  const updateTraining = (field: string, value: any) => {
    setState({
      ...state,
      training: {
        ...state.training,
        [field]: value
      }
    });
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: ''
      });
    }
  };
  const updateBatch = (field: string, value: any) => {
    setState({
      ...state,
      batch: {
        ...state.batch,
        [field]: value
      }
    });
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: ''
      });
    }
  };
  const validateStep = () => {
    const newErrors: Record<string, string> = {};
    if (currentStep === 1) {
      if (!state.training.nameBangla) newErrors.nameBangla = 'Required';
      if (!state.training.nameEnglish) newErrors.nameEnglish = 'Required';
      if (!state.training.category) newErrors.category = 'Required';
    }
    if (currentStep === 2) {
      if (!state.batch.nameBangla) newErrors.nameBangla = 'Required';
      if (!state.batch.nameEnglish) newErrors.nameEnglish = 'Required';
      if (!state.batch.trainers.length) newErrors.trainers = 'Select at least one trainer';
      if (!state.batch.startDate) newErrors.startDate = 'Required';
      if (!state.batch.endDate) newErrors.endDate = 'Required';
      if (state.batch.venueType === 'online' && !state.batch.onlineLink) newErrors.onlineLink = 'Required';
      if (state.batch.venueType === 'offline' && !state.batch.venueId) newErrors.venueId = 'Required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleNext = () => {
    if (validateStep()) {
      setCurrentStep(currentStep + 1);
    }
  };
  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };
  const trainerOptions = trainers.map(t => ({
    value: t.id,
    label: t.name
  }));
  const venueOptions = venues.map(v => ({
    value: v.id,
    label: v.name
  }));
  const trainingOptions = [{
    value: '1',
    label: state.training.nameEnglish || 'Current Training'
  }];
  const selectedTraineesData = state.selectedTrainees.map(id => ({
    id,
    name: `Trainee ${id}`,
    phone: '01712345678',
    email: `trainee${id}@example.com`
  }));
  return <div className="space-y-0" data-id="element-432">
      <StepIndicator currentStep={currentStep} steps={steps} data-id="element-433" />

      <div className="p-8 max-w-5xl mx-auto" data-id="element-434">
        {currentStep === 1 && <Step1TrainingInfo data={state.training} onChange={updateTraining} errors={errors} data-id="element-435" />}

        {currentStep === 2 && <Step2BatchInfo data={state.batch} onChange={updateBatch} errors={errors} trainers={trainerOptions} venues={venueOptions} trainings={trainingOptions} onAddTrainer={trainer => console.log('Add trainer', trainer)} onAddVenue={venue => console.log('Add venue', venue)} data-id="element-436" />}

        {currentStep === 3 && <Step3Schedule schedules={state.schedules} onChange={schedules => setState({
        ...state,
        schedules
      })} trainers={trainerOptions.filter(t => state.batch.trainers.includes(t.value))} data-id="element-437" />}

        {currentStep === 4 && <Step4Trainees selectedTrainees={state.selectedTrainees} onChange={trainees => setState({
        ...state,
        selectedTrainees: trainees
      })} data-id="element-438" />}

        {currentStep === 5 && <Step5Publish data={state} onChange={published => setState({
        ...state,
        isPublished: published
      })} data-id="element-439" />}

        {currentStep === 6 && <Step6Attendance schedules={state.schedules} trainees={selectedTraineesData} attendance={state.attendance} onChange={(scheduleId, attendance) => setState({
        ...state,
        attendance: {
          ...state.attendance,
          [scheduleId]: attendance
        }
      })} data-id="element-440" />}

        {currentStep === 7 && <Step7Certificates trainees={selectedTraineesData} attendance={state.attendance} schedules={state.schedules} certificates={state.certificates} onChange={certificates => setState({
        ...state,
        certificates
      })} data-id="element-441" />}

        <div className="flex justify-between mt-8" data-id="element-442">
          {currentStep > 1 && <Button variant="secondary" onClick={handleBack} data-id="element-443">
              Back
            </Button>}
          {currentStep < 7 && <Button onClick={handleNext} className="ml-auto" data-id="element-444">
              {currentStep === 5 ? 'Publish Training' : 'Save & Next'}
            </Button>}
          {currentStep === 6 && <Button onClick={handleNext} className="ml-auto" data-id="element-445">
              Save Attendance
            </Button>}
        </div>
      </div>
    </div>;
}